import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import {
  DrawerType,
  RydeUiUnit,
  selectedTableRowsIdsAtomFamily,
  useDrawers,
  useIsMobile,
} from "@ryde/shared";

import { FloatingMenuButton } from "../../floating-menu.styled";

const entity: RydeUiUnit = "driver";

export const DriverExpand: FC = () => {
  const selectedIds = useRecoilValue(selectedTableRowsIdsAtomFamily(entity));
  const { isMobile } = useIsMobile();
  const { openDrawer } = useDrawers();
  const { t } = useTranslation();

  const onSendDriversMessage = useEvent(() => {
    openDrawer({
      drawerProps: {
        type: DrawerType.BulkDriversMessage,
        selectedDriverIds: selectedIds,
      },
    });
  });

  return (
    <FloatingMenuButton onClick={onSendDriversMessage}>
      {!isMobile && <SVG_MUI.MessageLines3SVG className="pointer" />}
      <span>{t("general.message")}</span>
    </FloatingMenuButton>
  );
};
